import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  ClipboardList,
  Timer,
  FileText,
  Wallet,
  BarChart3,
  Settings,
  Scale,
} from "lucide-react";
import { cn } from "@/lib/cn";
import { useIntakes } from "@/intakes/IntakesContext";

export const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/clients-matters", label: "Clients", icon: Users, testid: "nav-clients-matters" },
  { to: "/workbench", label: "Workbench", icon: ClipboardList, testid: "nav-workbench" },
  { to: "/quick-log", label: "Quick Time Log", icon: Timer, testid: "nav-quick-log" },
  { to: "/invoices", label: "Invoices", icon: FileText, testid: "nav-invoices" },
  { to: "/payments", label: "Payments", icon: Wallet, testid: "nav-payments" },
  { to: "/reports", label: "Reports", icon: BarChart3, testid: "nav-reports" },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

export function Sidebar() {
  const { newCount } = useIntakes();
  return (
    <aside className="hidden md:flex w-64 shrink-0 flex-col border-r border-border bg-surface">
      <div className="flex h-16 items-center gap-2.5 border-b border-border px-6">
        <span className="grid h-8 w-8 place-items-center rounded-md bg-primary text-primary-foreground">
          <Scale className="h-[18px] w-[18px]" />
        </span>
        <span className="font-serif text-xl font-semibold tracking-tight text-foreground">
          MatterTab
        </span>
      </div>

      <nav className="flex-1 space-y-1 px-3 py-5">
        {NAV_ITEMS.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              cn(
                "group relative flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium font-sans transition-colors",
                isActive
                  ? "bg-accent text-foreground"
                  : "text-muted-foreground hover:bg-accent/50 hover:text-foreground"
              )
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={cn(
                    "absolute left-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-r-full bg-primary transition-opacity",
                    isActive ? "opacity-100" : "opacity-0"
                  )}
                />
                <Icon className="h-[18px] w-[18px]" />
                {label}
                {to === "/settings" && newCount > 0 && (
                  <span
                    data-testid="nav-intakes-badge"
                    className="ml-auto grid h-5 min-w-5 place-items-center rounded-full bg-primary px-1.5 text-[11px] font-semibold text-primary-foreground"
                  >
                    {newCount}
                  </span>
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-border px-6 py-4">
        <p className="text-xs text-muted-foreground">
          Billing engine <span className="text-status-paid">online</span>
        </p>
      </div>
    </aside>
  );
}
